import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import {
  postLogin,
} from "../../../helpers/auth_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, navigate } }) {
  try {
    const response = yield call(postLogin, {
      params: {
        login: user.email,
        password: user.password,
      }
    });
    localStorage.setItem("authUser", JSON.stringify(response));
    yield put(loginSuccess(response));

    navigate(user?.role === 'admin' ? "/dashboard" : '/orders');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
